import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import { extractSadadInfo } from "@/apis/checkout/sendSadadInvoice";
import { toast } from "sonner";
export var api__getOrderTracking = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
    var _res$data;
    var res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetcher().get("/order-tracking/view", {
            params: {
              id: id
            }
          });
        case 1:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
      }
    }, _callee);
  }));
  return function api__getOrderTracking(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__cancelWarranty = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(order_uuid) {
    var _res$data2, _res$data$data$warran, _res$data3, _res$data3$data, _res$data$data$warran2, _res$data4, _res$data4$data, res, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetcher().post("/order-tracking/cancel-warranty", {
            order_uuid: order_uuid
          });
        case 1:
          res = _context2.v;
          if (res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.success) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, null);
        case 2:
          return _context2.a(2, {
            warrantyV2: (_res$data$data$warran = res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$data = _res$data3.data) === null || _res$data3$data === void 0 ? void 0 : _res$data3$data.warrantyV2) !== null && _res$data$data$warran !== void 0 ? _res$data$data$warran : null,
            warrantyPriceDetailsV3: (_res$data$data$warran2 = res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : (_res$data4$data = _res$data4.data) === null || _res$data4$data === void 0 ? void 0 : _res$data4$data.warrantyPriceDetailsV3) !== null && _res$data$data$warran2 !== void 0 ? _res$data$data$warran2 : null
          });
        case 3:
          _context2.p = 3;
          _t = _context2.v;
          toast.error("حدث خطأ، يرجى المحاولة مرة أخرى");
          return _context2.a(2, null);
      }
    }, _callee2, null, [[0, 3]]);
  }));
  return function api__cancelWarranty(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__getWarrantyDetails = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(order_id, warranty_id) {
    var _res$data5, _res$data$data, _res$data6, res, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return fetcher().get("/order-tracking/get-warranty-details", {
            params: {
              order_id: order_id,
              warranty_id: warranty_id
            }
          });
        case 1:
          res = _context3.v;
          if (res !== null && res !== void 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.success) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, null);
        case 2:
          return _context3.a(2, (_res$data$data = res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.data) !== null && _res$data$data !== void 0 ? _res$data$data : null);
        case 3:
          _context3.p = 3;
          _t2 = _context3.v;
          return _context3.a(2, null);
      }
    }, _callee3, null, [[0, 3]]);
  }));
  return function api__getWarrantyDetails(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var api__getTrackingStepDetails = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref4) {
    var _res$data7;
    var orderId, stepNum, isFinance, apiUrl, res, response;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          orderId = _ref4.orderId, stepNum = _ref4.stepNum, isFinance = _ref4.isFinance;
          apiUrl = isFinance ? "/finance-tracking/view-step?order_id=".concat(orderId, "&step=").concat(stepNum, "&include=remainingBnplOptions") : "/order-tracking/view-step?order_id=".concat(orderId, "&step=").concat(stepNum, "&include=remainingBnplOptions,warrantyV2");
          _context4.n = 1;
          return fetcher().get(apiUrl);
        case 1:
          res = _context4.v;
          response = (res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.data) || {};
          if (!isFinance) {
            _context4.n = 2;
            break;
          }
          return _context4.a(2, response);
        case 2:
          return _context4.a(2, _objectSpread(_objectSpread({}, response), extractSadadInfo(response)));
        case 3:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return function api__getTrackingStepDetails(_x5) {
    return _ref5.apply(this, arguments);
  };
}();